import ClientResource from 'App/resources/Client';
import logError from 'App/babel/helpers/logError';

import type Client from 'App/resources/Model/Client';
import EventBus from 'App/services/EventBus';

export const removeAsSubAccount = (client: Client) => {
	ClientResource.save({ id: client.id, operationalAccount: null })
		.then(() => EventBus.broadcast('account.subaccountsDeleted'))
		.catch(error => logError(error));
};
